// GENERATED by scripts/bake_star_catalog.py from the Yale Bright Star Catalogue
// (5th revised ed., CDS V/50, public domain). Rows: [raDeg, decDeg, vmag, bv], J2000,
// vmag <= 4.0. Do not edit by hand; re-run the script.
export const STARS = [
  [2.097, 29.091, 2.06, -0.11],
  [2.295, 59.15, 2.27, 0.34],
  [2.353, -45.748, 3.88, 1.03],
  [3.309, 15.184, 2.83, -0.23],
  [4.857, -8.824, 3.56, 1.22],
  [6.438, -77.254, 2.8, 0.62],
  [6.571, -42.306, 2.39, 1.09],
  [6.551, -43.68, 3.94, 0.17],
  [9.243, 53.897, 3.66, -0.2],
  [9.832, 30.861, 3.27, 1.28],
  [10.127, 56.537, 2.23, 1.17],
  [10.898, -17.987, 2.04, 1.02],
  [12.275, 57.816, 3.44, 0.57],
  [14.177, 60.717, 2.47, -0.15],
  [14.188, 38.499, 3.87, 0.13],
  [16.521, -46.719, 3.31, 0.89],
  [17.148, -10.182, 3.45, 1.16],
  [17.433, 35.621, 2.06, 1.58],
  [17.096, -55.246, 3.92, -0.08],
  [21.006, -8.183, 3.6, 1.06],
  [21.454, 60.235, 2.68, 0.13],
  [37.953, 89.264, 2.02, 0.6],
  [22.091, -43.318, 3.41, 1.57],
  [22.871, 15.346, 3.62, 0.97],
  [22.813, -49.073, 3.95, 0.99],
  [24.498, 48.628, 3.57, 1.28],
  [24.429, -57.237, 0.46, -0.16],
  [26.017, -15.938, 3.5, 0.72],
  [27.865, -10.335, 3.73, 1.14],
  [28.599, 63.67, 3.38, -0.15],
  [28.27, 29.579, 3.41, 0.49],
  [28.66, 20.808, 2.64, 0.13],
  [28.99, -51.609, 3.7, 0.85],
  [30.859, 72.421, 3.98, -0.01],
  [30.001, -21.078, 4.0, 1.57],
  [29.692, -61.57, 2.86, 0.28],
  [30.975, 42.33, 2.26, 1.37],
  [31.793, 23.462, 2.0, 1.15],
  [32.386, 34.987, 3.0, 0.14],
  [34.128, -51.512, 3.56, -0.12],
  [34.836, -2.978, 3.04, 1.42],
  [40.825, 3.236, 3.47, 0.09],
  [42.674, 55.896, 3.76, 1.68],
  [42.496, 27.261, 3.63, -0.1],
  [43.565, 52.763, 3.95, 0.74],
  [43.47, -49.89, 4.0, 2.11],
  [44.107, -8.898, 3.89, 1.11],
  [44.565, -40.305, 3.24, 0.14],
  [45.57, 4.09, 2.53, 1.64],
  [46.199, 53.506, 2.93, 0.7],
  [46.294, 38.84, 3.39, 1.65],
  [47.042, 40.956, 2.12, -0.05],
  [47.374, 44.857, 3.8, 0.98],
  [48.018, -28.987, 3.87, 0.52],
  [49.879, -21.758, 3.69, 1.62],
  [51.081, 49.861, 1.79, 0.48],
  [51.203, 9.029, 3.6, 0.89],
  [51.793, 9.733, 3.74, -0.09],
  [53.232, -9.458, 3.73, 0.88],
  [55.731, 47.788, 3.01, -0.13],
  [56.08, 32.288, 3.83, 0.05],
  [56.298, 42.579, 3.77, 0.42],
  [55.812, -9.763, 3.54, 0.92],
  [56.219, 24.113, 3.7, -0.11],
  [56.457, 24.368, 3.87, -0.07],
  [56.871, 24.105, 2.87, -0.09],
  [56.05, -64.807, 3.85, 1.13],
  [57.29, 24.053, 3.63, -0.09],
  [58.533, 31.884, 2.85, 0.12],
  [56.81, -74.239, 3.24, 1.62],
  [59.463, 40.01, 2.89, -0.18],
  [59.508, -13.509, 2.95, 1.59],
  [60.17, 12.49, 3.47, -0.12],
  [60.789, 5.989, 3.91, 0.03],
  [63.5, -42.294, 3.86, 1.1],
  [63.606, -62.474, 3.35, 0.91],
  [64.948, 15.628, 3.65, 0.99],
  [64.474, -33.798, 3.56, -0.12],
  [65.734, 17.543, 3.76, 0.98],
  [66.009, -34.017, 3.96, 1.49],
  [67.154, 19.18, 3.53, 1.01],
  [67.144, 15.962, 3.84, 0.95],
  [67.165, 15.871, 3.4, 0.18],
  [68.98, 16.509, 0.85, 1.54],
  [69.08, -3.353, 3.93, -0.21],
  [68.887, -30.562, 3.82, 0.98],
  [68.499, -55.045, 3.27, -0.1],
  [69.545, -14.304, 3.87, 1.09],
  [72.46, 6.961, 3.19, 0.45],
  [72.802, 5.605, 3.69, -0.17],
  [73.563, 2.441, 3.72, -0.18],
  [74.248, 33.166, 2.69, 1.53],
  [75.492, 43.823, 2.99, 0.54],
  [75.62, 41.076, 3.75, 1.22],
  [76.629, 41.234, 3.17, -0.18],
  [76.365, -22.371, 3.19, 1.46],
  [76.963, -5.086, 2.79, 0.13],
  [78.233, -16.206, 3.31, -0.11],
  [79.172, 45.998, 0.08, 0.8],
  [78.635, -8.202, 0.12, -0.03],
  [79.402, -6.844, 3.6, -0.11],
  [81.119, -2.397, 3.36, -0.17],
  [81.283, 6.35, 1.64, -0.22],
  [81.573, 28.608, 1.65, -0.13],
  [82.061, -20.759, 2.84, 0.82],
  [83.002, -0.299, 2.23, -0.22],
  [82.803, -35.471, 3.87, 1.14],
  [83.182, -17.822, 2.58, 0.21],
  [83.785, 9.934, 3.54, -0.18],
  [83.858, -5.91, 2.77, -0.24],
  [84.053, -1.202, 1.7, -0.19],
  [84.411, 21.142, 3.0, -0.19],
  [83.406, -62.49, 3.76, 0.82],
  [84.687, -2.6, 3.81, -0.24],
  [85.19, -1.943, 2.05, -0.21],
  [84.912, -34.074, 2.64, -0.12],
  [86.116, -22.448, 3.6, 0.47],
  [86.739, -14.822, 3.55, 0.1],
  [86.939, -9.67, 2.06, -0.17],
  [87.873, 39.149, 3.97, 1.13],
  [86.821, -51.066, 3.85, 0.17],
  [87.83, -20.879, 3.81, 0.99],
  [87.74, -35.768, 3.12, 1.16],
  [88.793, 7.407, 0.5, 1.85],
  [89.882, 54.285, 3.72, 1.0],
  [89.101, -14.168, 3.71, 0.33],
  [89.882, 44.947, 1.9, 0.03],
  [89.93, 37.213, 2.62, -0.08],
  [89.787, -42.815, 3.96, 1.14],
  [93.719, 22.507, 3.28, 1.6],
  [93.714, -6.275, 3.98, 1.32],
  [95.078, -30.063, 3.02, -0.19],
  [95.74, 22.514, 2.88, 1.64],
  [95.675, -17.956, 1.98, -0.23],
  [95.528, -33.436, 3.85, 0.88],
  [95.988, -52.696, -0.72, 0.15],
  [99.428, 16.399, 1.93, 0.0],
  [99.171, -19.256, 3.95, 1.06],
  [99.44, -43.196, 3.17, -0.11],
  [100.983, 25.131, 2.98, 1.4],
  [101.322, 12.896, 3.36, 0.43],
  [101.287, -16.716, -1.46, 0.0],
  [102.46, -32.509, 3.96, -0.23],
  [103.197, 33.961, 3.6, 0.1],
  [102.047, -61.941, 3.27, 0.21],
  [102.484, -50.615, 2.93, 1.2],
  [103.533, -24.184, 3.87, 1.73],
  [104.656, -28.972, 1.5, -0.21],
  [105.43, -27.935, 3.47, 1.73],
  [106.027, 20.57, 3.79, 0.79],
  [105.756, -23.833, 3.02, -0.08],
  [107.098, -26.393, 1.84, 0.68],
  [107.187, -70.499, 3.78, 1.04],
  [108.703, -26.773, 3.85, -0.17],
  [109.523, 16.54, 3.58, 0.11],
  [109.286, -37.098, 2.7, 1.62],
  [110.031, 21.982, 3.53, 0.34],
  [109.207, -67.957, 3.98, 0.79],
  [111.432, 27.798, 3.79, 1.03],
  [111.024, -29.303, 2.45, -0.08],
  [111.788, 8.289, 2.9, -0.09],
  [112.308, -43.301, 3.25, 1.51],
  [113.65, 31.889, 2.88, 0.04],
  [113.65, 31.888, 1.98, 0.03],
  [114.825, 5.225, 0.38, 0.42],
  [115.312, -9.551, 3.93, 1.02],
  [116.112, 24.398, 3.57, 0.93],
  [116.329, 28.026, 1.14, 1.0],
  [115.952, -28.955, 3.96, 0.18],
  [116.314, -37.969, 3.61, 1.73],
  [115.455, -72.606, 3.95, 1.04],
  [117.324, -24.86, 3.34, 1.24],
  [118.054, -40.576, 3.73, 1.04],
  [119.195, -52.982, 3.47, -0.18],
  [120.896, -40.003, 2.25, -0.26],
  [121.886, -24.304, 2.81, 0.43],
  [122.383, -47.337, 1.78, -0.22],
  [124.129, 9.186, 3.52, 1.48],
  [125.628, -59.51, 1.86, 1.28],
  [126.415, -3.906, 3.9, -0.02],
  [127.566, 60.718, 3.36, 0.84],
  [126.434, -66.137, 3.77, 1.13],
  [130.026, -35.308, 3.97, 0.94],
  [130.157, -46.649, 3.84, 0.71],
  [130.073, -52.922, 3.62, -0.18],
  [131.171, 18.154, 3.94, 1.08],
  [130.898, -33.186, 3.68, -0.18],
  [131.694, 6.419, 3.38, 0.68],
  [131.176, -54.708, 1.96, 0.04],
  [131.507, -46.042, 3.91, 0.0],
  [133.848, 5.946, 3.11, 1.0],
  [134.802, 48.042, 3.14, 0.19],
  [133.762, -60.645, 3.84, -0.1],
  [135.16, 41.783, 3.97, 0.44],
  [135.906, 47.157, 3.6, 0.0],
  [136.039, -47.098, 3.75, 1.2],
  [135.612, -66.396, 4.0, 0.14],
  [136.999, -43.432, 2.21, 1.66],
  [137.742, -58.967, 3.44, -0.19],
  [137.819, -62.317, 3.97, -0.18],
  [138.591, 2.314, 3.88, -0.06],
  [138.3, -69.717, 1.68, 0.0],
  [139.711, 36.802, 3.82, 0.06],
  [139.273, -59.275, 2.25, 0.18],
  [140.264, 34.392, 3.13, 1.55],
  [140.528, -55.011, 2.5, -0.18],
  [141.897, -8.659, 1.98, 1.44],
  [142.882, 63.062, 3.67, 0.33],
  [143.214, 51.677, 3.17, 0.46],
  [142.675, -40.467, 3.6, 0.36],
  [142.805, -57.034, 3.13, 1.55],
  [144.964, -1.143, 3.91, 1.32],
  [145.287, 9.892, 3.52, 0.49],
  [146.463, 23.774, 2.98, 0.8],
  [146.312, -62.508, 3.69, 1.22],
  [147.748, 59.039, 3.8, 0.29],
  [146.775, -65.072, 3.01, 0.28],
  [148.191, 26.007, 3.88, 1.22],
  [149.216, -54.568, 3.54, -0.08],
  [151.833, 16.763, 3.52, -0.03],
  [152.093, 11.967, 1.35, -0.11],
  [152.647, -12.354, 3.61, 1.01],
  [153.684, -42.122, 3.85, 0.05],
  [154.173, 23.417, 3.44, 0.31],
  [154.274, 42.914, 3.45, 0.03],
  [153.434, -70.038, 3.32, -0.08],
  [154.271, -61.332, 3.4, 1.54],
  [154.993, 19.842, 2.61, 1.15],
  [154.994, 19.841, 3.8, 0.6],
  [155.582, 41.499, 3.05, 1.59],
  [156.523, -16.836, 3.81, 1.48],
  [156.099, -74.032, 4.0, 0.35],
  [156.97, -58.739, 3.82, 0.31],
  [158.203, 9.307, 3.85, -0.14],
  [158.006, -61.685, 3.32, -0.09],
  [159.325, -48.226, 3.84, 0.3],
  [160.739, -64.394, 2.76, -0.22],
  [161.692, -49.42, 2.69, 0.9],
  [162.406, -16.194, 3.11, 1.25],
  [163.328, 34.215, 3.83, 1.04],
  [163.373, -58.853, 3.78, 0.95],
  [165.46, 56.383, 2.37, -0.02],
  [165.932, 61.751, 1.79, 1.07],
  [167.416, 44.499, 3.01, 1.14],
  [167.147, -58.975, 3.91, 1.23],
  [168.527, 20.524, 2.56, 0.12],
  [168.56, 15.429, 3.34, -0.01],
  [169.62, 33.094, 3.48, 1.4],
  [169.835, -14.779, 3.56, 1.12],
  [170.252, -54.491, 3.89, -0.15],
  [170.981, 10.529, 3.94, 0.41],
  [172.851, 69.331, 3.84, 1.62],
  [173.25, -31.858, 3.54, 0.94],
  [173.945, -63.02, 3.13, -0.04],
  [176.512, 47.779, 3.71, 1.18],
  [176.402, -66.729, 3.64, 0.16],
  [177.265, 14.572, 2.14, 0.09],
  [177.674, 1.765, 3.61, 0.55],
  [178.457, 53.695, 2.44, 0.0],
  [182.09, -50.723, 2.6, -0.12],
  [182.531, -22.62, 3.0, 1.33],
  [182.913, -52.369, 3.96, -0.15],
  [183.786, -58.749, 2.8, -0.23],
  [183.857, 57.032, 3.31, 0.08],
  [183.952, -17.542, 2.59, -0.11],
  [184.977, -0.667, 3.89, 0.02],
  [185.34, -60.401, 3.59, 1.42],
  [186.65, -63.099, 1.33, -0.24],
  [186.652, -63.099, 1.73, -0.26],
  [187.01, -50.231, 3.91, -0.19],
  [187.466, -16.516, 2.95, -0.05],
  [187.791, -57.113, 1.63, 1.59],
  [188.117, -72.133, 3.87, -0.15],
  [188.597, -23.397, 2.65, 0.89],
  [188.371, 69.788, 3.87, -0.13],
  [189.296, -69.136, 2.69, -0.2],
  [189.426, -48.541, 3.86, 0.05],
  [190.379, -48.96, 2.17, -0.01],
  [190.415, -1.449, 3.65, 0.36],
  [190.415, -1.449, 3.68, 0.6],
  [191.57, -68.108, 3.05, -0.18],
  [191.93, -59.689, 1.25, -0.23],
  [193.507, 55.96, 1.77, -0.02],
  [193.901, 3.397, 3.38, 1.58],
  [194.007, 38.318, 2.9, -0.12],
  [195.567, -71.549, 3.62, 1.18],
  [195.544, 10.959, 2.83, 0.94],
  [199.73, -23.172, 3.0, 0.92],
  [200.149, -36.712, 2.75, 0.04],
  [200.981, 54.925, 2.27, 0.02],
  [200.985, 54.922, 3.95, 0.13],
  [201.298, -11.161, 0.98, -0.23],
  [202.761, -39.407, 3.88, 1.17],
  [203.673, -0.596, 3.37, 0.11],
  [204.972, -53.466, 2.3, -0.22],
  [207.376, -41.688, 3.41, -0.22],
  [206.885, 49.313, 1.86, -0.19],
  [207.404, -42.474, 3.04, -0.17],
  [208.885, -47.288, 2.55, -0.22],
  [208.671, 18.398, 2.68, 0.58],
  [209.568, -42.101, 3.83, -0.21],
  [209.67, -44.804, 3.87, -0.2],
  [210.956, -60.373, 0.61, -0.23],
  [211.593, -26.683, 3.27, 1.12],
  [211.671, -36.37, 2.06, 1.01],
  [211.097, 64.376, 3.65, -0.05],
  [213.915, 19.183, -0.04, 1.23],
  [214.851, -46.058, 3.55, -0.18],
  [217.958, 30.371, 3.58, 1.3],
  [218.02, 38.308, 3.03, 0.19],
  [218.877, -42.158, 2.31, -0.19],
  [219.9, -60.835, -0.01, 0.71],
  [219.9, -60.836, 1.33, 0.88],
  [220.627, -64.975, 3.19, 0.24],
  [220.482, -47.388, 2.3, -0.2],
  [221.965, -79.045, 3.83, 1.43],
  [220.49, -37.794, 4.0, -0.17],
  [220.765, -5.658, 3.88, 0.38],
  [221.247, 27.074, 2.7, 0.97],
  [221.562, 1.893, 3.72, -0.01],
  [222.72, -16.042, 2.75, 0.15],
  [222.676, 74.156, 2.08, 1.47],
  [224.633, -43.134, 2.68, -0.22],
  [224.79, -42.104, 3.13, -0.2],
  [225.487, 40.391, 3.5, 0.97],
  [226.017, -25.282, 3.29, 1.7],
  [227.984, -48.738, 3.87, -0.05],
  [228.071, -52.099, 3.41, 0.92],
  [229.728, -68.679, 2.89, 0.0],
  [228.876, 33.315, 3.47, 0.95],
  [229.252, -9.383, 2.61, -0.11],
  [230.343, -40.648, 3.22, -0.22],
  [230.452, -36.261, 3.56, 1.54],
  [230.67, -44.689, 3.37, -0.18],
  [230.182, 71.834, 3.05, 0.05],
  [231.232, 58.966, 3.29, 1.16],
  [231.957, 29.106, 3.68, 0.28],
  [233.785, -41.167, 2.78, -0.2],
  [233.882, -14.789, 3.91, 1.01],
  [233.7, 10.537, 3.8, 0.26],
  [233.7, 10.539, 3.8, 0.26],
  [233.672, 26.715, 2.23, -0.02],
  [234.256, -28.135, 3.58, 1.38],
  [234.664, -29.778, 3.66, -0.17],
  [235.686, 26.296, 3.84, 0.0],
  [236.067, 6.426, 2.65, 1.17],
  [236.547, 15.422, 3.67, 0.06],
  [237.405, -3.43, 3.53, -0.04],
  [237.74, -33.627, 3.95, -0.04],
  [237.704, 4.478, 3.71, 0.15],
  [238.785, -63.431, 2.85, 0.29],
  [239.221, -29.214, 3.88, -0.2],
  [239.113, 15.662, 3.85, 0.48],
  [239.713, -26.114, 2.89, -0.19],
  [240.03, -38.397, 3.41, -0.22],
  [240.083, -22.622, 2.32, -0.12],
  [239.876, 25.92, 2.0, 0.1],
  [241.359, -19.806, 2.62, -0.07],
  [241.702, -20.669, 3.96, -0.04],
  [243.86, -63.686, 3.85, 1.11],
  [243.586, -3.694, 2.74, 1.58],
  [244.58, -4.692, 3.24, 0.96],
  [245.297, -25.593, 2.89, 0.13],
  [244.935, 46.313, 3.89, -0.15],
  [245.48, 19.153, 3.75, 0.27],
  [248.363, -78.897, 3.89, 0.91],
  [245.998, 61.514, 2.74, 0.91],
  [247.352, -26.432, 0.96, 1.83],
  [247.555, 21.49, 2.77, 0.94],
  [247.728, 1.984, 3.82, 0.01],
  [248.971, -28.216, 2.82, -0.25],
  [249.29, -10.567, 2.56, 0.02],
  [250.322, 31.603, 2.81, 0.65],
  [252.166, -69.028, 1.92, 1.44],
  [250.724, 38.922, 3.53, 0.92],
  [252.446, -59.041, 3.76, 1.57],
  [252.541, -34.293, 2.29, 1.15],
  [252.968, -38.047, 3.08, -0.2],
  [253.084, -38.017, 3.57, -0.21],
  [253.646, -42.361, 3.62, 1.37],
  [254.655, -55.99, 3.13, 1.6],
  [254.417, 9.375, 3.2, 1.15],
  [255.073, 30.926, 3.92, -0.01],
  [257.595, -15.725, 2.43, 0.06],
  [258.038, -43.239, 3.33, 0.41],
  [257.197, 65.715, 3.17, -0.12],
  [258.662, 14.39, 3.48, 1.44],
  [258.758, 24.839, 3.14, 0.08],
  [258.762, 36.809, 3.16, 1.44],
  [260.502, -24.999, 3.27, -0.22],
  [261.325, -55.53, 2.85, 1.46],
  [261.348, -56.377, 3.34, -0.13],
  [262.775, -60.684, 3.62, -0.1],
  [262.691, -37.296, 2.69, -0.22],
  [262.96, -49.876, 2.95, -0.17],
  [263.402, -37.104, 1.63, -0.22],
  [262.608, 52.301, 2.79, 0.98],
  [264.33, -42.998, 1.87, 0.4],
  [263.734, 12.56, 2.08, 0.15],
  [264.397, -15.399, 3.54, 0.26],
  [265.622, -39.03, 2.41, -0.22],
  [266.433, -64.724, 3.62, 1.19],
  [264.866, 46.006, 3.8, -0.18],
  [265.868, 4.567, 2.77, 1.16],
  [266.896, -40.127, 3.03, 0.51],
  [266.615, 27.721, 3.42, 0.75],
  [266.973, 2.707, 3.75, 0.04],
  [267.465, -37.043, 3.21, 1.17],
  [268.382, 56.873, 3.75, 1.18],
  [269.063, 37.251, 3.86, 1.35],
  [269.757, -9.774, 3.34, 0.99],
  [269.441, 29.248, 3.7, 0.94],
  [269.152, 51.489, 2.23, 1.52],
  [270.161, 2.932, 3.97, 0.02],
  [271.658, -50.092, 3.66, -0.08],
  [271.452, -30.424, 2.99, 1.0],
  [271.837, 9.564, 3.73, 0.12],
  [271.886, 28.762, 3.83, -0.03],
  [273.441, -21.059, 3.86, 0.23],
  [274.407, -36.762, 3.11, 1.56],
  [275.249, -29.828, 2.7, 1.38],
  [275.328, -2.899, 3.26, 0.94],
  [276.043, -34.385, 1.85, -0.03],
  [275.925, 21.77, 3.84, 1.18],
  [276.743, -45.968, 3.51, -0.17],
  [276.993, -25.422, 2.81, 1.04],
  [275.264, 72.733, 3.57, 0.49],
  [278.802, -8.244, 3.85, 1.33],
  [279.235, 38.784, 0.03, 0.0],
  [281.414, -26.991, 3.17, -0.11],
  [282.52, 33.363, 3.45, 0.0],
  [283.816, -26.297, 2.02, -0.22],
  [284.432, -21.107, 3.51, 1.18],
  [284.736, 32.689, 3.24, -0.05],
  [285.653, -29.88, 2.6, 0.08],
  [286.171, -21.742, 3.77, 1.01],
  [286.735, -27.671, 3.32, 1.19],
  [286.352, 13.863, 2.99, 0.01],
  [286.562, -4.883, 3.44, -0.09],
  [287.441, -21.024, 2.89, 0.35],
  [288.139, 67.662, 3.07, 1.0],
  [289.276, 53.369, 3.77, 0.96],
  [290.418, -17.847, 3.93, 0.22],
  [290.972, -40.616, 3.97, -0.1],
  [291.375, 3.115, 3.36, 0.32],
  [292.68, 27.96, 3.08, 1.13],
  [292.426, 51.73, 3.79, 0.14],
  [296.565, 10.613, 2.72, 1.52],
  [296.244, 45.131, 2.87, -0.03],
  [296.847, 18.534, 3.82, 1.41],
  [297.696, 8.868, 0.77, 0.22],
  [298.118, 1.006, 3.9, 0.89],
  [297.043, 70.268, 3.83, 0.89],
  [300.148, -72.911, 3.96, -0.03],
  [298.828, 6.407, 3.71, 0.86],
  [299.077, 35.083, 3.89, 1.02],
  [299.689, 19.492, 3.47, 1.57],
  [302.182, -66.182, 3.56, 0.76],
  [302.826, -0.821, 3.23, -0.07],
  [303.408, 46.741, 3.79, 1.28],
  [303.868, 47.714, 3.98, 1.52],
  [304.514, -12.545, 3.57, 0.94],
  [305.253, -14.781, 3.08, 0.79],
  [306.412, -56.735, 1.94, -0.2],
  [305.557, 40.257, 2.2, 0.68],
  [309.392, -47.291, 3.11, 1.0],
  [309.387, 14.595, 3.63, 0.44],
  [309.91, 15.912, 3.77, -0.06],
  [311.24, -66.203, 3.42, 0.16],
  [310.358, 45.28, 1.25, 0.09],
  [311.553, 33.97, 2.46, 1.03],
  [311.919, -9.496, 3.77, 0.0],
  [311.322, 61.839, 3.43, 0.92],
  [313.702, -58.454, 3.65, 1.25],
  [314.293, 41.167, 3.94, 0.02],
  [316.233, 43.928, 3.72, 1.65],
  [318.234, 30.227, 3.2, 0.99],
  [318.698, 38.046, 3.72, 0.39],
  [318.956, 5.248, 3.92, 0.53],
  [319.645, 62.586, 2.44, 0.22],
  [321.667, -22.411, 3.74, 1.0],
  [322.89, -5.571, 2.91, 0.83],
  [322.165, 70.561, 3.23, -0.22],
  [325.369, -77.39, 3.76, 1.0],
  [325.023, -16.662, 3.68, 0.32],
  [326.047, 9.875, 2.39, 1.53],
  [326.76, -16.127, 2.87, 0.29],
  [328.482, -37.365, 3.01, -0.12],
  [331.446, -0.32, 2.96, 0.98],
  [332.058, -46.961, 1.74, -0.13],
  [331.753, 25.345, 3.76, 0.44],
  [332.55, 6.198, 3.53, 0.08],
  [332.714, 58.201, 3.35, 1.57],
  [334.625, -60.26, 2.86, 1.39],
  [335.414, -1.387, 3.84, -0.05],
  [337.317, -43.496, 3.97, 1.03],
  [337.293, 58.415, 3.75, 0.6],
  [337.823, 50.282, 3.77, 0.01],
  [340.365, 10.831, 3.4, -0.09],
  [340.667, -46.885, 2.1, 1.6],
  [340.75, 30.221, 2.94, 0.86],
  [341.633, 23.566, 3.95, 1.07],
  [342.139, -51.317, 3.49, 0.08],
  [342.501, 24.602, 3.48, 0.93],
  [342.42, 66.201, 3.52, 1.05],
  [343.154, -7.58, 3.74, 1.64],
  [343.662, -15.821, 3.27, 0.05],
  [344.413, -29.622, 1.16, 0.09],
  [345.48, 42.326, 3.62, -0.09],
  [345.944, 28.083, 2.42, 1.67],
  [346.19, 15.205, 2.49, -0.04],
  [347.362, -21.172, 3.66, 1.22],
  [347.59, -45.247, 3.9, 1.02],
  [349.358, -58.236, 3.99, 0.4],
  [349.291, 3.282, 3.69, 0.92],
  [350.743, -20.101, 3.97, 1.1],
  [354.391, 46.458, 3.82, 1.01],
  [354.837, 77.632, 3.21, 1.03],
];
